function trackEvent(trackEventObject) {
  // const request = trackEventObject.payload.data;

  // // TOOD: Fix analytics to actually send to wherever it needs to go
  // //console.log(`WIDGET ANALYTICS: ${JSON.stringify(request)}`);
}

//========================================
// Boiler plate code
//
// Probably no need to change stuff below
//========================================
// mock track event
export function mockTrackEvent (data) {
  const dataRequest = {
      payload: {
          data : data || {}
      },
      context : "MOCK WIDGET"
  };

  return trackEvent(dataRequest);
}

export function mockRegisterTrackingContextCallback(cb) {

}